import { useTranslations } from 'next-intl';
import { RequestServiceActionButtons } from '@cat-ecom/pcc-components';

const RequestEquipmentServiceFooter = ({
  activeIndex,
  isMd,
  onBackCancel,
  disableCTA,
  isLoading
}) => {
  const t = useTranslations();
  return (
    <div slot="footer" className="d-flex">
      <RequestServiceActionButtons
        continueLabel={
          activeIndex === 2 || isMd ? t('REQUEST_SERVICE') : t('UC_NEXT')
        }
        backLabel={isMd ? t('CANCEL') : t('UC_BACK')}
        isMD={!isMd}
        continueBtnProps={{
          fullWidth: !isMd,
          type: 'submit',
          variant: 'primary',
          disabled: disableCTA || isLoading
        }}
        backBtnProps={{
          fullWidth: !isMd,
          onClick: onBackCancel,
          disabled: (!isMd && activeIndex === 0) || isLoading
        }}
      />
    </div>
  );
};

export default RequestEquipmentServiceFooter;
